import { render, staticRenderFns } from "./TenantStart.vue?vue&type=template&id=284c134c&"
import script from "./TenantStart.vue?vue&type=script&lang=js&"
export * from "./TenantStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports